import {ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { updateDossierService } from 'src/app/services/Dossier/updateDossier.service';

@Component({
    selector: 'dialog-dossier-label',
    templateUrl: 'label.component.html',
    styleUrls: ['label.component.scss']
})
export class DialogDossierLabelComponent implements OnInit {

    isLoading = false;
    dossier;
    dossierLabel = "";
    duplication = false;
    title = "Modification de libellé du dossier";

    constructor(
        public dialogRef: MatDialogRef<DialogDossierLabelComponent>,
        public updateDossierService: updateDossierService,
        public cdf: ChangeDetectorRef,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    ngOnInit() {
        this.dossier = this.data.dossier;
        this.duplication = this.data.duplication;
        this.dossierLabel = this.data.dossier.dossier_label;
        this.title = this.data.title ? this.data.title : this.title;
    }

    save() {
        if (!this.duplication) {
            this.updateDossierService.setDossierLabel(this.dossier.id, this.dossierLabel)
            .subscribe((response) => {
                this.dismissDialog(true);
            })
        } else {
            this.dismissDialog(true);
        }
    }

    dismissDialog(isSaved = false) {
        this.dialogRef.close({label: this.dossierLabel, saved: isSaved});
    }
}